import { DateTime } from 'luxon';

const MISSING = '—';

const part = (value: unknown): string => {
  const text = value === null || value === undefined ? '' : String(value).trim();
  return text || MISSING;
};

/** One offer dimension as typed (e.g. "100+ / 150+5"), or — when missing. */
export function formatOfferDimension(value: string | number | null | undefined): string {
  return part(value);
}

/** "thick × width × length" of an offer, with — for each missing part. Values are kept as typed. */
export function formatOfferDimensions(
  offer: { thick?: string | number | null; width?: string | number | null; length?: string | number | null } | null | undefined,
): string {
  return [offer?.thick, offer?.width, offer?.length].map(part).join(' × ');
}

/** Offer date as dd/MM/yyyy (UTC calendar day, offer dates are stored at UTC midnight), or — when missing or invalid. */
export function formatOfferDate(date: string | Date | DateTime | null | undefined): string {
  if (!date) {
    return MISSING;
  }
  const value =
    date instanceof DateTime
      ? date
      : date instanceof Date
      ? DateTime.fromJSDate(date)
      : DateTime.fromISO(date);
  return value.isValid ? value.toUTC().toFormat('dd/MM/yyyy') : MISSING;
}
